import styled from '@emotion/styled';
import { rgba } from 'polished';

import CheckIcon from '@/assets/icons/icon_check.svg';
import { mq } from '@/utility/mediaQuery';
import { defaultTheme } from '@/utility/theme';

export const CheckBoxWrapper = styled.div(() =>
  mq({
    display: 'inline-flex',
    alignItems: 'center',
    position: 'relative',
    label: {
      marginLeft: defaultTheme.spacing.xs,
    },
  }),
);

export const StyledCheckBox = styled.input(
  (props: { disabled?: boolean; checked?: boolean }) =>
    mq({
      height: '20px',
      width: '20px',
      border: `1px solid ${defaultTheme.border.color.mediumGray}`,
      borderRadius: defaultTheme.border.radius.xs,
      backgroundColor: props.disabled
        ? defaultTheme.background.lightGray
        : defaultTheme.background.white,
      WebkitAppearance: 'none !important',
      MozAppearance: 'none !important',
      appearance: 'none !important',
      '&:checked': {
        border: `1px solid ${defaultTheme.border.color.primary}`,
        background: defaultTheme.background.primary,
        backgroundImage: `url(${CheckIcon})`,
        backgroundSize: '14px',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      },
      cursor: props.disabled ? 'not-allowed' : 'pointer',
      flexShrink: 0,
    }),
);

export const CheckBoxLabel = styled.label((props: { disabled?: boolean }) =>
  mq({
    color: props.disabled
      ? rgba(defaultTheme.text.default, 0.3)
      : defaultTheme.text.default,
    cursor: `${props.disabled ? 'default' : 'pointer'} !important`,
  }),
);
